import { atom } from "recoil";

const updateBasketState = atom({
    key: "updateBasketState",
    default: {
        BoolUpdate: false,
    },
});

export { updateBasketState };